/**
 * 商城Vuex-mutations
 */
export default {
    saveUserName(state, username) {
        state.username = username;
    },
    saveCartCount(state, count) {
        state.cartCount = count;
    },
    catId(state, catId) {
        state.catId = catId;
    },
    catParentId(state, catParentId) {
        state.catParentId = catParentId;
    },
    saveUserInfo(state, userInfo) {
        state.userInfo = userInfo;
    },
    saveSettimg(state, setting) {
        state.setting = setting;
    },
    saveCatList(state, list) {
        state.cat_list = list;
    },
    saveHomeInfo(state, homeInfo) {
        state.home_info = homeInfo;
    }
}
